import { Instance, Promize, Table } from '@siposdani87/sui-js';
import { app } from '../app';
import { ItemService } from '@services/itemService';
import { initTable } from '@utils/collectionSetup';
import { DashboardController } from './dashboardController';

export class ItemsIndexByUserController extends DashboardController {
    static readonly inject = ['instances', 'itemService'] as const;

    userId!: string;
    itemsTable!: Table;

    constructor(
        instances: Instance,
        private itemService: ItemService,
    ) {
        super(instances);
    }

    protected override _initLayout(): void {
        this.userId = this.state.getParam('userId');

        this._initToolbarButtons();

        this._drawContent();
    }

    protected override _drawContent(): Promize | boolean {
        this._initItemTable();
        return true;
    }

    private _initToolbarButtons(): void {
        this.helper.iconButton('.btn-users-home', this.dom, () => {
            this.state.goBack('users.home');
        });
    }

    private _initItemTable(): void {
        this.itemsTable = initTable(
            this.itemsTable,
            this.dom,
            '.items-table',
            this.itemService,
            {
                entityKey: 'items',
                fetchData: (params) =>
                    this.itemService.getAllByUser(this.userId, params),
            },
        )!;
    }
}

export const itemsIndexByUserController = app.controller(
    'itemsIndexByUserController',
    ItemsIndexByUserController,
);
